// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_57Q","left":"styles_left__QZQ0W"};